/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-11-26 11:34:56
 * @LastEditors: 诺
 * @LastEditTime: 2022-06-28 15:40:59
 * @Description: file content
 * requiresAuth 1静默授权 2用户授权  0无需授权
 */
import MyRouter from "@/routers/index";
import config from "./config";
let myRouter = new MyRouter({
  fake: config.env[process.env.VUE_APP_SERVE_ENV].routersActWxauth.fake,
  servicesActWxjssdk: config.env[process.env.VUE_APP_SERVE_ENV].servicesActWxjssdk,
});

myRouter.router.addRoutes([
  {
    path: "/layout",
    name: "layout",
    meta: {
      title: "",
      requiresAuth: 0,
    },
    component: () => import("./layout.vue"),
    children: [
      {
        path: "/index",
        name: "index",
        meta: {
          title: "点亮",
          requiresAuth: 2,
        },
        component: () => import("./index.vue"),
      },
      {
        path: "/lightup",
        name: "lightup",
        meta: {
          title: "点亮",
          requiresAuth: 2,
        },
        component: () => import("./lightup.vue"),
      },
      {
        path: "/luck",
        name: "luck",
        meta: {
          title: "抽奖",
          requiresAuth: 2,
        },
        component: () => import("./luck.vue"),
      },
      {
        path: "/rule",
        name: "rule",
        meta: {
          title: "活动规则",
          requiresAuth: 2,
        },
        component: () => import("./rule.vue"),
      },
      {
        path: "/ranking",
        name: "ranking",
        meta: {
          title: "排行榜",
          requiresAuth: 2,
        },
        component: () => import("./ranking.vue"),
      },
      {
        path: "/prize",
        name: "prize",
        meta: {
          title: "我的奖品",
          requiresAuth: 2,
        },
        component: () => import("./prize.vue"),
      },
      {
        path: "/friends",
        name: "friends",
        meta: {
          title: "我的好友",
          requiresAuth: 2,
        },
        component: () => import("./friends.vue"),
      },
      {
        path: "/writeoff",
        name: "writeoff",
        meta: {
          title: "核销",
          requiresAuth: 1,
        },
        component: () => import("./writeoff.vue"),
      },
    ],
  },
]);
export default myRouter.router;
